export function isWindowsSystem() {
    return /Windows|Win32|Win64/i.test(navigator.userAgent);
}
